module.exports = __webpack_public_path__ + "static/desktop/img/faq-book-left.593954b8.jpg";